import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import { handleOnCreateOrderQueryStarted } from "appRedux/helpers/orderApiHelpers"
import { CreateOrderRequestPayload, CreateOrderResponseDto } from "types/order.types"

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: baseQueryWithMiddlewares("/order"),
  endpoints: (builder) => ({
    createOrder: builder.mutation<CreateOrderResponseDto, CreateOrderRequestPayload>({
      query: (body) => ({
        url: "",
        method: "PUT",
        body: body
      }),
      onQueryStarted: handleOnCreateOrderQueryStarted
    })
  })
})

export const {
  useCreateOrderMutation
} = orderApi
